import { View, Text, styled } from 'tamagui'

const BadgePill = styled(View, {
  borderRadius: '$borderRadiusFull',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '$accentLight',
  borderWidth: 1,
  borderColor: '$accent',
  variants: {
    badgeSize: {
      sm: { paddingHorizontal: 5, paddingVertical: 1 },
      md: { paddingHorizontal: 7, paddingVertical: 2 },
    },
  } as const,
  defaultVariants: {
    badgeSize: 'md',
  },
})

const BadgeLabel = styled(Text, {
  fontFamily: '$fontBody',
  fontWeight: '700',
  color: '$accent',
  letterSpacing: 0.5,
  variants: {
    badgeSize: {
      sm: { fontSize: 9 },
      md: { fontSize: 11 },
    },
  } as const,
  defaultVariants: {
    badgeSize: 'md',
  },
})

interface ProBadgeProps {
  size?: 'sm' | 'md'
}

export function ProBadge({ size = 'md' }: ProBadgeProps) {
  return (
    <BadgePill badgeSize={size}>
      <BadgeLabel badgeSize={size}>PRO</BadgeLabel>
    </BadgePill>
  )
}
